export const teamMemebers = [
    {id: '1', name: 'Sodiq'},
    {id: '2', name: 'Tunji'},
    {id: '3', name: 'Micheal'},
];
